<template>
  <div class="mx-auto">
    <b-row>
      <b-col xxs="12">
        <div class="row mt-5">
          <div class="col">
            <h1 class="font-weight-boldest mega-text m-0 p-0">Register</h1>
              <h6 class="font-weight-bold">
              Your first property free.
            </h6>

             <b-alert variant="success" class="p-5 my-5" show>
          <b-media>
            <template #aside>
              <i class="lni lni-offer font-size-26"></i>
            </template>

            <h5>Start Free</h5>
            Your first property &amp; first Email with 10mb disc space for
            <strong> free every month. </strong>
          </b-media>
        </b-alert>

            <div class="card mb-5">
              <div class="card-body">
                <form-base
                title="Sign Up"
                  :submit-status="submitStatus"
                  action="Sign Up"
                  :errors="errors"
                  :loading="loading"
                  v-on:handleSubmit="handleSubmit"
                >
                  <template v-slot:fields>
                    <form-group label="Full Name" :required="true">
                      <input
                        ref="name"
                        type="text"
                        @blur="$v.user.name.$touch"
                        class="form-control"
                        :class="{ 'is-invalid': $v.user.name.$error }"
                        v-model="user.name"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.user.name.required"
                      >
                        Please enter full name
                      </div>
                    </form-group>

                    <form-group label="Email" :required="true">
                      <input
                        type="email"
                        class="form-control"
                        :class="{ 'is-invalid': $v.user.email.$error }"
                        v-model="user.email"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.user.email.required"
                      >
                        Please enter email address
                      </div>
                      <div class="invalid-feedback" v-if="!$v.user.email.email">
                        invalid email address
                      </div>
                    </form-group>

                    <form-group label="Password" :required="true">
                      <input
                        type="password"
                        class="form-control"
                        :class="{ 'is-invalid': $v.user.password.$error }"
                        v-model="user.password"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.user.password.minLength"
                      >
                        Please enter password with a minimun of 6 characters
                      </div>
                    </form-group>

                    <form-group label="Company Name" :required="true">
                      <input
                        type="text"
                        @blur="$v.company.company_name.$touch"
                        class="form-control"
                        :class="{ 'is-invalid': $v.company.company_name.$error }"
                        v-model="company.company_name"
                      />

                      <div
                        class="invalid-feedback"
                        v-if="!$v.company.company_name.required"
                      >
                        Please enter company name
                      </div>
                    </form-group>

                    
                      <input
                        
                        type="hidden"
                        class="form-control"
                        @blur="$v.company.code.$touch"
                        :class="{ 'is-invalid': $v.company.code.$error }"
                        v-model="company.code"
                      />
                     

                    <form-group label="Contact Number" :required="true">
                      <input
                        type="text"
                        class="form-control"
                        v-model="company.contact_number"
                        @blur="$v.company.contact_number.$touch"
                        :class="{
                          'is-invalid': $v.company.contact_number.$error,
                        }"
                      />
                    </form-group>

                   

                    <form-group label="Company Physical Address" :required="true">
                      <textarea-autosize
                        @blur="$v.company.physical_address.$touch"
                        :class="{
                          'is-invalid': $v.company.physical_address.$error,
                        }"
                        class="form-control"
                        v-model="company.physical_address"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.company.physical_address.required"
                      >
                        Please enter address
                      </div>
                    </form-group>

                    <form-group label="Company Charges VAT?">
                      <b-form-checkbox
                        size="lg"
                        v-model="company.is_vatable"
                        value="1"
                        unchecked-value="0"
                      >
                      </b-form-checkbox>
                    </form-group>

                    <form-group
                      label="VAT Rate%"
                      v-if="company.is_vatable == 1"
                      :required="true"
                    >
                      <input
                        type="number"
                        max="50"
                        min="1"
                        @blur="$v.company.vat_rate.$touch"
                        :class="{ 'is-invalid': $v.company.vat_rate.$error }"
                        class="form-control w-50"
                        v-model="company.vat_rate"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.company.vat_rate.required"
                      >
                        Please enter vat rate
                      </div>
                    </form-group>

                    <form-group
                      label="VAT Number"
                      v-if="company.is_vatable == 1"
                      :required="true"
                    >
                      <input
                        type="text"
                        @blur="$v.company.vat_number.$touch"
                        :class="{ 'is-invalid': $v.company.vat_number.$error }"
                        class="form-control"
                        v-model="company.vat_number"
                      />
                      <div
                        class="invalid-feedback"
                        v-if="!$v.company.vat_number.required"
                      >
                        Please enter vat number
                      </div>
                    </form-group>
                  </template>
                </form-base>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  required,
  email,
  minLength,
  requiredIf,
} from "vuelidate/lib/validators";
import formBase from "@/components/common/FormBase";
import formGroup from "@/components/common/FormGroup";
import userRepo from "@/api/repos/userRepo";

export default {
  components: {
    formBase,
    formGroup,
  },

  data() {
    return {
      user: {},
      company: {
        is_vatable: 0,
        code:"001"
      },
      loading: false,
      errors: null,
      submitStatus: null,
    };
  },

  mounted() {
    this.$refs.name.focus();
  },

  validations: {
    user: {
      name: {
        required,
      },
      email: {
        required,
        email,
      },
      password: {
        required,
        minLength: minLength(6),
      },
    },
    company: {
      company_name: {
        required,
      },
      code: {
        required,
      },
       contact_number: {
        required,
      },
     
      physical_address: {
        required,
      },
      vat_rate: {
        required: requiredIf(function (company) {
          return company.is_vatable == 1;
        }),
      },
      vat_number: {
        required: requiredIf(function (company) {
          return company.is_vatable == 1;
        }),
      },
    },
  },

  methods: {
    async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
      this.$v.$touch();
      if (this.$v.$invalid) {        
        this.submitStatus = "ERROR";
        this.loading = false;
      } else {
        try {
          await userRepo.guestSignUp({...this.user,...this.company});
           this.$router.push({name:'login'})
          this.$root.$bvToast.toast('Account Created Successfully', {
            title: 'Please sign in',
            autoHideDelay: 5000,
            variant: 'success',
          })
        } catch (error) {
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
            this.$root.$bvToast.toast("Form Errors", {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          } else {
            this.$root.$bvToast.toast("Something Went Wrong", {
              title: error.response.data.message,
              autoHideDelay: 3000,
              variant: "danger",
            });
          }
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },
  },
};
</script>
